import styled from 'styled-components';
import { DynamicContent } from '../../../../../app-kit/components/DynamicContent/DynamicContent';
import { Badge, paletteHelper, Text, typographyHelper } from '@property.com.au/ui-kit';
import type { FunctionComponent } from 'react';
import { ContentBrick } from '../../../../../app-kit/components/ContentBrick/ContentBrick';
import { BadgeVariant, mapBadgeVariant } from '../../../../../app-kit/helpers/mapBadgeVariant';
import {
  ButtonFragment,
  mapDynamicContentItems,
  TextFragment,
  WebLinkFragment,
} from '../../../../../app-kit/components/DynamicContent/helpers/mapDynamicContentItem';

const TitleText = styled(Text)`
  ${typographyHelper('subtitle01')};
  font-size: 1rem;
`;

const SubtitleText = styled(Text)`
  ${typographyHelper('subtitle02')};
  color: ${paletteHelper('textSecondary')};
`;

const StyledDynamicContent = styled(DynamicContent)`
  ${typographyHelper('body02')}
`;

interface InternetConnectionBrickProps {
  connection: {
    title: string;
    subtitle?: string | null;
    badgeV2?: {
      text: string;
      variant: BadgeVariant;
    } | null;
    description: (WebLinkFragment | TextFragment | ButtonFragment)[];
  };
  className?: string;
}

export const InternetConnectionBrick: FunctionComponent<InternetConnectionBrickProps> = ({
  connection,
  className,
}) => {
  const { title, subtitle, badgeV2, description } = connection;

  return (
    <ContentBrick
      titleComponent={<TitleText as="h3">{title}</TitleText>}
      subtitleComponent={<SubtitleText>{subtitle}</SubtitleText>}
      subtitle={subtitle}
      isSubBrick={true}
      headerChildren={
        badgeV2 && <Badge variant={mapBadgeVariant(badgeV2.variant)}>{badgeV2.text}</Badge>
      }
      className={className}
    >
      <StyledDynamicContent
        dynamicContents={mapDynamicContentItems(description)}
        textColorVariant="textSecondary"
      />
    </ContentBrick>
  );
};
